var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"section"},[_c('div',{staticClass:"itemFixed-nav"},[_c('div',{staticClass:"itemFixed-nav-content"},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":_vm.imageUrl,"headers":_vm.headers,"list-type":"picture-card","name":"uploadFile","data":{
            asImage: true,
            fieldName: 'headImageUrl',
            model: _vm.uplaodModel,
          },"on-success":(res, file) => {
              _vm.imageListHandleAvatarSuccess(res, file);
            },"on-remove":(res, file) => {
              _vm.imageListHandleRemove(res, file);
            },"multiple":"","limit":100,"file-list":_vm.imageList}},[_c('i',{staticClass:"el-icon-plus"})])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }